import { MiniLibraryActions } from '../types/MiniLibraryActions';
import { MiniLibraryBody } from '../types/MiniLibraryBody';
import MiniLibraryDetails from '../types/MiniLibraryDetails';
interface InitialState {
    list: MiniLibraryBody[],
    count: number,
    libDetails: MiniLibraryDetails
}

const initialState: InitialState = {
    list: [],
    count: 0,
    libDetails: { question: [], formulas: [], studymaterial: [], testpapers: [], _id: "" }
}

const miniLibraryReducers = (state = initialState, action: MiniLibraryActions) => {
    switch (action.type) {
        case 'MINI_LIBRARY_LIST_SUCCESS': {
            return { ...state, list: action.data };
        }
        case 'MINI_LIBRARY_COUNT_SUCCESS': {
            return { ...state, count: action.data };
        }
        case 'MINI_LIBRARY_DETAILS_DATA': {
            let _id = action.data._id;
            delete action.data._id;

            let listD: any[] = state.list.map(l => {
                if (l._id === _id) {
                    l["contentMapped"] = action.data;
                    l["isDataUpdated"] = true;
                }
                return l;
            });
            return {
                ...state,
                libDetails: {
                    ...initialState.libDetails,
                    ...action.data
                },
                list: [
                    ...listD
                ]
            };
        }
        default: {
            return state;
        }
    }
}

export default miniLibraryReducers;